import { render, staticRenderFns } from "./bidding_purchase_return_list.vue?vue&type=template&id=96494a26&scoped=true"
import script from "./bidding_purchase_return_list.vue?vue&type=script&lang=js"
export * from "./bidding_purchase_return_list.vue?vue&type=script&lang=js"
import style0 from "./bidding_purchase_return_list.vue?vue&type=style&index=0&id=96494a26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96494a26",
  null
  
)

export default component.exports